import React from 'react';
import { FC } from 'react';
import { IconProps } from '../types';

export const ProofOfIdentityIcon: FC<IconProps> = ({ width = '24', height = '24', className }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 22 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M14.75 5.75H16.75M14.75 9.75H16.75M4.91998 10.7501C5.12612 10.1641 5.50908 9.65653 6.016 9.29748C6.52292 8.93844 7.12879 8.74561 7.74998 8.74561C8.37117 8.74561 8.97705 8.93844 9.48396 9.29748C9.99088 9.65653 10.3738 10.1641 10.58 10.7501M9.75 6.75C9.75 7.85457 8.85457 8.75 7.75 8.75C6.64543 8.75 5.75 7.85457 5.75 6.75C5.75 5.64543 6.64543 4.75 7.75 4.75C8.85457 4.75 9.75 5.64543 9.75 6.75ZM2.75 0.75H18.75C19.8546 0.75 20.75 1.64543 20.75 2.75V12.75C20.75 13.8546 19.8546 14.75 18.75 14.75H2.75C1.64543 14.75 0.75 13.8546 0.75 12.75V2.75C0.75 1.64543 1.64543 0.75 2.75 0.75Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
